import { useState } from 'react';

export const STATUS_OPTIONS = [
    { value: 'aktiv', label: 'Aktiv', color: '#4f46e5' },
    { value: 'pausiert', label: 'Pausiert', color: '#f59e0b' },
    { value: 'abgeschlossen', label: 'Abgeschlossen', color: '#10b981' }
];

export function usePersistentListViewState() {
    const [searchTerm, setSearchTerm] = useState('');
    const [statusFilter, setStatusFilter] = useState(STATUS_OPTIONS.map(o => o.value));
    const [dateRange, setDateRange] = useState({ start: null, end: null });
    const [dateMode, setDateMode] = useState('combined'); // 'calendar', 'undated', 'combined'
    const [workerFilter, setWorkerFilter] = useState([]);
    const [vehicleFilter, setVehicleFilter] = useState([]);
    const [kolonnenFilter, setKolonnenFilter] = useState([]);
    const [workerSearch, setWorkerSearch] = useState('');
    const [vehicleSearch, setVehicleSearch] = useState('');
    const [kolonneSearch, setKolonneSearch] = useState('');
    const [openDropdown, setOpenDropdown] = useState(null);
    const [sortConfig, setSortConfig] = useState({ key: 'start_datetime', direction: 'desc' });
    const [selectedIds, setSelectedIds] = useState([]);
    const [hidePast, setHidePast] = useState(true);

    const resetAllFilters = () => {
        setStatusFilter(STATUS_OPTIONS.map(o => o.value));
        setDateRange({ start: null, end: null });
        setDateMode('combined');
        setWorkerFilter([]);
        setVehicleFilter([]);
        setKolonnenFilter([]);
        setSearchTerm('');
        setOpenDropdown(null);
        setSelectedIds([]);
        setHidePast(true);
    };

    return {
        searchTerm, setSearchTerm,
        statusFilter, setStatusFilter,
        dateRange, setDateRange,
        dateMode, setDateMode,
        workerFilter, setWorkerFilter,
        vehicleFilter, setVehicleFilter,
        kolonnenFilter, setKolonnenFilter,
        workerSearch, setWorkerSearch,
        vehicleSearch, setVehicleSearch,
        kolonneSearch, setKolonneSearch,
        openDropdown, setOpenDropdown,
        sortConfig, setSortConfig,
        selectedIds, setSelectedIds,
        hidePast, setHidePast,
        resetAllFilters,
        STATUS_OPTIONS
    };
}
